import type { SupportedFileType, SupportedMimeType } from '../types'
import { SUPPORTED_FILE_TYPES } from '../types'

export function isSupportedFileType(fileType: string): fileType is SupportedFileType {
  return SUPPORTED_FILE_TYPES.includes(fileType as SupportedFileType)
}

export function getFileExtensionFromName(fileName: string): string {
  if (!fileName) return ''

  const parts = fileName.split('.')

  // If there's only one part, no extension
  if (parts.length < 2) return ''

  // If file starts with . and has only 2 parts (e.g., .htaccess), no extension
  if (parts[0] === '' && parts.length === 2) return ''

  const extension = parts.pop()!

  // If extension is empty (file ends with .), return empty string
  return extension ? extension.toLowerCase() : ''
}

export function getFileExtensionFromMimeType(mimeType: SupportedMimeType): string {
  const mimeTypeMap: Record<SupportedMimeType, SupportedFileType> = {
    'application/msword': 'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/pdf': 'pdf',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  }

  return mimeTypeMap[mimeType] || ''
}

export function getMimeTypeFromExtension(extension: string): SupportedMimeType | '' {
  const extensionMap: Record<SupportedFileType, SupportedMimeType> = {
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    pdf: 'application/pdf',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  }

  return extensionMap[extension as SupportedFileType] || ''
}
